module.exports = __webpack_public_path__ + "img/japan-genitourinary-diseases-female.0c962b55.png";